import styled from "styled-components";

export const DetailInfoCard = styled.div`
  background-color: var(--sub-pink);
  border-radius: 6px;
  padding: 22px 16px;
`;
